module.exports = __webpack_public_path__ + "img/cooperative-group-woman.8ca0971f.svg";